import { Ref, ref } from "vue";
import { DaccachError } from "@/business/shared/commons/DaccachError";

const defaultError: DaccachError = {
  error: {
    error: ""
  },
};

export function errorManagerActions() {
  function transform(error: string): string {
    const message: Ref<string> = ref("");

    try {
      const errorJson = JSON.parse(JSON.stringify(error));
      const messageError = JSON.parse(errorJson.detail);
      message.value = JSON.stringify(messageError.error);
    } catch (e) {
      message.value = error.toString().substr(6);
    }

    return message.value;
  }

  function transformDaccach(error: string): DaccachError {
    const daccachError: Ref<DaccachError> = ref(defaultError);
    daccachError.value = JSON.parse(JSON.stringify(error));

    return daccachError.value;
  }

  function createError(errorMessage: string): DaccachError {
    return {
      error: {
        error: errorMessage,
      },
    };
  }

  return {
    transform,
    transformDaccach,
    createError,
  };
}